import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { axiosAuth } from "../config/axiosInstances"
import { API_XANO_CERTIFIED_BASE_URL } from "../config/api_config"
import { Api_url } from "../common/api_url"

const initialState = {
    data: {

    },
    showQuizAnalysisModal: false,
    userFromUnPaidReminderMessage: false,
    startLoaderSeconds: false,
    showAdditionalQuestionModal: false,
    showBackRouteModal: false,
    backCountInGoalTakingPage: 0,
    backCountInCertificateDownloadPage: 0,
    backCountInDraftPage: 0,
    modalOnceShownInGoalTakingPage: true,
    modalOnceOpenedInCertificateDownloadPage: true,
    modalOnceOpenedInDraftPage: true
}

export const getUserQuizAnalysis = createAsyncThunk(
    'getUserQuizAnalysis',
    async ({ certified_user_skill_quiz_id }) => {
        try {
            const response = await axiosAuth.get(API_XANO_CERTIFIED_BASE_URL + Api_url.GetUserQuizAnalysis, {
                params: {
                    certified_user_skill_quiz_id
                }
            })
            return response.data?.data
        } catch (error) {
            throw error
        }
    }
)

const unPaidUserSlice = createSlice({
    name: 'unPaidUserDetails',
    initialState,
    reducers: {
        setShowQuizAnalysisModal: (state, action) => {
            state.showQuizAnalysisModal = action.payload
        },
        setUserFromUnPaidReminderMessage: (state, action) => {
            state.userFromUnPaidReminderMessage = action.payload
        },
        setStartLoaderSeconds: (state, action) => {
            state.startLoaderSeconds = action.payload
        },
        setShowAdditionalQuestionModal: (state, action) => {
            state.showAdditionalQuestionModal = action.payload
        },
        setShowBackRouteModal: (state, action) => {
            state.showBackRouteModal = action.payload
        },
        setBackCountInGoalTakingPage: (state) => {
            if(!state.backCountInGoalTakingPage){
                state.backCountInGoalTakingPage = 0
            }
            state.backCountInGoalTakingPage += 1
        },
        setBackCountInCertificateDownloadPage: (state) => {
            if(!state.backCountInCertificateDownloadPage){
                state.backCountInCertificateDownloadPage = 0
            }
            state.backCountInCertificateDownloadPage += 1
        },
        setBackCountInDraftPage: (state) => {
            if(!state.backCountInDraftPage){
                state.backCountInDraftPage = 0
            }
            state.backCountInDraftPage += 1
        },
        resetUnPaidUserDetails: () => initialState
    },
    extraReducers: (builder) => {
        builder.addCase(getUserQuizAnalysis.fulfilled, (state, action) => {
            state.data = action.payload
        })
    }
})

export const { setShowQuizAnalysisModal, setUserFromUnPaidReminderMessage, resetUnPaidUserDetails, setStartLoaderSeconds, setShowAdditionalQuestionModal, setShowBackRouteModal, setBackCountInDraftPage, setBackCountInCertificateDownloadPage, setBackCountInGoalTakingPage } = unPaidUserSlice.actions
export const selectQuizAnalysisData = (state) => state.unPaidUserDetails?.data
export const selectShowQuizAnalysisModal = (state) => state.unPaidUserDetails?.showQuizAnalysisModal
export const selectUserFromUnPaidReminderMessage = (state) => state.unPaidUserDetails?.userFromUnPaidReminderMessage
export const selectStartLoaderSeconds = (state) => state.unPaidUserDetails?.startLoaderSeconds
export const selectShowAdditionalQuestionModal = (state) => state.unPaidUserDetails?.showAdditionalQuestionModal
export const selectShowBackRouteModal = (state) => state.unPaidUserDetails?.showBackRouteModal
export const selectBackCountInDraftPage = (state) => state.unPaidUserDetails?.backCountInDraftPage
export const selectBackCountInCertificateDownloadPage = (state) => state.unPaidUserDetails?.backCountInCertificateDownloadPage
export const selectBackCountInGoalTakingPage = (state) => state.unPaidUserDetails?.backCountInGoalTakingPage

export default unPaidUserSlice.reducer